export default {
  // 模式
  "common.mode.auto": "Chế độ tự sử dụng năng lượng tự sản xuất",
  "common.mode.economy": "Chế độ kinh tế",
  "common.mode.exigency": "Chế độ khẩn cấp",

  // 设备
  "common.grid": "Mạng điện",
  "common.evChargers": "Bộ sạc xe điện",
  "common.evCharger": "Bộ sạc xe điện",
  "common.pv": "Quang điện (PV)",
  "common.inverter": "Bộ biến đổi (inverter)",
  "common.pcs": "Bộ biến đổi + pin",
  "common.terminal": "Thiết bị đầu cuối",
  "common.airc": "Máy điều hòa",
  "common.engine": "Động cơ",
  "common.battery": "Pin",
  "common.metter": "Đồng hồ đo điện",
  "common.other": "Khác",
  "common.power": "Công suất",
  "common.powerTotal": "Tổng công suất",
  "common.voltage": "Điện áp",
  "common.electricity": "Điện năng",
  "common.current": "Dòng điện",
  "common.homeUsage": "Tổng tải tiêu thụ của nhà",
  "common.battery.power": "Công suất pin",

  // 数据
  "common.noDataAvailable": "Hiện không có dữ liệu~",
  "common.tips": "Gợi ý",
  "common.reset": "Đặt lại",
  "common.currencyUnit": "¥",
  "common.submiting": "Đang gửi... Vui lòng chờ...",
  "common.close": "Đóng",
  "common.from": "Từ",
  "common.useIn": "Dùng cho",
  "common.energyPercent": "Tỷ lệ dòng năng lượng",
  "common.dataFlow": "Dòng dữ liệu",
  "common.getDataIng": "Đang lấy dữ liệu... Vui lòng chờ...",
  "common.pageLoading": "Nội dung trang đang tải... Vui lòng chờ...",
  "common.reseting": "Đang đặt lại nội dung trang... Vui lòng chờ...",
  "common.save": "Lưu",
  "common.onlyNumberTips": "Chỉ có thể nhập số",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Lỗi",
  "common.charge": "Sạc",
  "common.discharge": "Phát (điện)",
  "common.buy": "Mua",
  "common.sell": "Bán",
  "common.loadingInfo": "Đang tải... Vui lòng chờ...",

  // 
  "common.moreFeatures": "Thêm tính năng",
  "common.confirm": "Xác nhận",
  "common.saveing": "Đang lưu... Vui lòng chờ...",
  "common.searchPlacholder": "Nhập từ khóa tìm kiếm",
  "common.iSee": "Tôi hiểu",
  "common.pageErrorTips1": "Ồ, có lỗi xảy ra trên trang~",
  "common.pageErrorTips2": "Hãy thử làm mới trang hoặc liên hệ bộ phận hỗ trợ~",
  "common.refresh": "Làm mới",
  "common.backToHome": "Quay về trang chủ",
  "common.checkTips": "Đang kiểm tra... Vui lòng chờ...",
  "common.back": "Quay lại",
  "common.cancel": "Hủy",
  "common.optional": "Tùy chọn",
  "common.required": "Bắt buộc",
  "common.status": "Trạng thái",
  "common.statusNoDelete": "Chưa xóa",
  "common.statusDelete": "Đã xóa",
  "common.submit": "Gửi",
  "common.disable": "Vô hiệu hóa",
  "common.enable": "Kích hoạt",
  "common.year": "năm",
  "common.month": "tháng",
  "common.day": "ngày",
  "common.version": "Phiên bản:",
  "common.backHome": " Quay về trang chủ",
  "common.backHomeSorry": " Rất tiếc, trang đã bị mất đường đi",
  "common.requestTips1": "Dữ liệu đang xử lý, vui lòng không gửi lại",
  "common.requestTips2": "Thông báo hệ thống",
  "common.requestTips3": "Trạng thái đăng nhập đã hết hạn, vui lòng đăng nhập lại",
  "common.requestTips4": "Đăng nhập lại",
  "common.requestTips5": "Phiên làm việc không hợp lệ hoặc đã hết hạn, vui lòng đăng nhập lại.",
  "common.requestTips6": "Lỗi máy chủ, vui lòng thử lại sau.",
  "common.requestTips7": "Yêu cầu giao diện hệ thống đã hết thời gian",
  "common.requestTips8": "Giao diện hệ thống",
  "common.requestTips9": "Lỗi",
  "common.iknow": "Tôi hiểu",
  "common.logoutSuccess": "Đăng xuất thành công",
  
  // 了解更多组件
  "common.knowMore.title": "Để biết thêm thông tin, vui lòng liên hệ Beineng",
  "common.knowMore.email": "Email liên hệ",
  "common.knowMore.phone": "Điện thoại liên hệ",
  "common.knowMore.wechat": "WeChat liên hệ",
  "common.knowMore.website": "Địa chỉ website chính thức",
  "common.knowMore.address": "Địa chỉ liên hệ",
  "common.knowMore.addressDetail": "Phòng 1205, 1301, Tòa nhà 5, Đường Thanh Hà số 8,ấp Hoàng Kinh Khen, Thị trấn Hoàng Giang, Thành phố Đông Quan, Tỉnh Quảng Đông",
  
  // 本地连接组件
  "common.localConnection": "Kết nối cục bộ",
  "common.operateInApp": "Thực hiện thao tác trong ứng dụng!",
  
  "common.enbleStaus": "Trạng thái kích hoạt",
  "common.battery.status": "Không sạc cũng không phát",

  "account.forgetThePassword": "Quên mật khẩu",
  "account.logInDirectly": "Đăng nhập ngay",
  "account.tips1": "Đang chuyển hướng đến trang... Vui lòng chờ...",
  "account.tips2": "Đầu tiên, vui lòng đọc và chấp nhận điều khoản sử dụng!",
  "account.autoLogin": "Đăng nhập tự động",
  "account.userLogin": "Đăng nhập người dùng",
  "account.registerTips": "Chưa có tài khoản? Nhấn vào đây để đăng ký",
  "account.userEmail": "Tên đăng nhập / Email",
  "account.userEmailTips": "Nhập tên đăng nhập hoặc email",
  "account.password": "Mật khẩu",
  "account.passwordTips": "Nhập mật khẩu",
  "account.submit": "Gửi",
  "account.submitTips": "Đang gửi... Vui lòng chờ...",
  "account.otherLoginTips": "Hoặc chọn phương thức đăng nhập khác",
  "account.userRegistration": "Đăng ký người dùng",
  "account.userName": "Tên đăng nhập",
  "account.userNameTips": "Nhập tên đăng nhập",
  "account.emailTips1": "Nhập địa chỉ email",
  "account.emailTips2": "Định dạng email không hợp lệ",
  "account.phone": "Số điện thoại",
  "account.phoneTips1": "Nhập số điện thoại",
  "account.phoneTips2": "Số điện thoại không hợp lệ",
  "account.phoneTips3": "Nhập số điện thoại",
  "account.passwordTips1": "Nhập mật khẩu (6-30 ký tự)",
  "account.passwordTips2": "Định dạng mật khẩu không hợp lệ: mật khẩu phải bao gồm chữ tiếng Anh, số, dấu gạch dưới, dấu gạch ngang và dấu chấm, độ dài 6-12 ký tự",
  "account.passwordTips3": "Hai mật khẩu nhập vào không khớp, vui lòng kiểm tra và nhập lại!",
  "account.passwordTips4": "Nhập mật khẩu: mật khẩu phải bao gồm chữ tiếng Anh, số, dấu gạch dưới, dấu gạch ngang và dấu chấm",
  "account.passwordTips5": "Xác nhận mật khẩu",
  "account.passwordTips6": "Nhập xác nhận mật khẩu",
  "account.passwordTips7": "Hai mật khẩu nhập vào không khớp, vui lòng kiểm tra và nhập lại!",
  "account.passwordTips8": "Nhập xác nhận mật khẩu",
  "account.passwordTips9": "Chúc mừng, đăng ký thành công!",
  "account.passwordTips10": "Tên đăng nhập của bạn là:",
  "account.emailIs": "Email là:",
  "account.goToLoginPage": "Sau s giây sẽ tự động chuyển đến trang đăng nhập",
  "account.goLogin": "Đăng nhập",
  "account.goRegister": "Đăng ký",
  "account.loginSuccess": "Đăng nhập thành công",
  "account.email": "Email",
  "account.sologn": "Chúng tôi tạo kế hoạch năng lượng tùy chỉnh cho bạn một cách cẩn thận",
  "account.pleaseAgree": "Tôi đã đọc và chấp nhận",
  "userAgreement.privacyPolicy": "chính sách bảo mật",

  "account.code": "Mã xác minh",
  "account.codeTips": "Nhập mã xác minh",
  "account.codeTips2": "Mã xác minh không hợp lệ",

    "account.inviteCodeTips": "Vui lòng nhập mã mời",
    "account.inviteCodeHint": "Vui lòng liên hệ nhân viên lắp đặt hoặc nhân viên vận hành bảo trì để nhận mã mời",
  "account.modifyPasswordByAccount": "Thay đổi mật khẩu qua tài khoản",
  "account.modifyPasswordByEmail": "Thay đổi mật khẩu qua email",
  "account.getPasswordByAccount": "Lấy lại mật khẩu qua tài khoản",
  "account.getPasswordByEmail": "Lấy lại mật khẩu qua email",

  "account.sendEmailTips": "Mã xác minh đã gửi đến email, vui lòng kiểm tra",
  "account.name": "Tên tài khoản",
  "account.newPassword": "Mật khẩu mới",
  "account.confirmNewPassword": "Xác nhận mật khẩu mới",
  "account.nameTips": "Nhập tên tài khoản",
  "account.passwordModifySuccess": "Thay đổi mật khẩu thành công",
  "account.emailCode": "Mã xác minh email",
  "account.emailCodeTips": "Nhập mã xác minh email",
  "account.emailCodeTips2": "Mã xác minh email không hợp lệ",
  "account.emailModifySuccess": "Thay đổi mật khẩu thành công",
  "account.passworTips1": "Mật khẩu của bạn đã được đặt lại thành công!",
  "account.passwordTips11": "Nhập xác nhận mật khẩu",
  "account.passwordTips12": "Nhập mật khẩu mới",
  "account.nickname": "Biệt danh người dùng",
  "account.modifyNickname": "Thay đổi biệt danh người dùng",
  "account.modifyNicknameSuccess": "Thay đổi biệt danh người dùng thành công!",
  "account.nicknameTips": "Nhập biệt danh người dùng",
  "account.nicknameError": "Thay đổi biệt danh người dùng thất bại!",

  "account.login": "Đăng nhập",
  "account.quickRegister": "Đăng ký nhanh",
  "account.sendCode": "Gửi mã xác minh",
  "account.sendTips": "Sau s giây có thể gửi lại",
  "account.sendEmailIng": "Đang gửi email... Vui lòng chờ...",
  "account.emailNotEmpty": "Địa chỉ email không được để trống",
  "account.registerAccount": "Đăng ký tài khoản",
  "account.registerWelcome": "Chào mừng đến với đăng ký SusprSafe",
  "account.usernameLimit": "Tên đăng nhập phải bắt đầu bằng chữ và chỉ có thể chứa chữ, số và dấu gạch dưới, độ dài 5-15 ký tự",

  "copyright.desc2": "Thông tin đăng ký website: Đăng ký ICP Quảng Đông số 2021169764",

  "editUserInfo.editUserInformation": "Chỉnh sửa thông tin người dùng",
  "editUserInfo.modifyUsername": "Thay đổi tên đăng nhập",
  "editUserInfo.changePictures": "Thay đổi ảnh đại diện",
  "editUserInfo.savePicturesSuccess": "Ảnh đại diện người dùng đã lưu thành công",
  "editUserInfo.saveError": "Lưu thất bại",
  "editUserInfo.pictureLimit": "Kích thước ảnh phải nhỏ hơn 2 MB",
  "editUserInfo.uploadPicture": "Tải ảnh đại diện lên",
  "editUserInfo.picturePreview": "Xem trước",
  
  "editUserInfo.bindPhoneNumber": "Liên kết số điện thoại",
  "editUserInfo.bindEmail": "Liên kết email",
  "editUserInfo.changePassword": "Thay đổi mật khẩu",

  "editUserInfo.notificationSettings": "Cài đặt thông báo",
  "editUserInfo.editAccount": "Chỉnh sửa thông tin tài khoản người dùng",
  "editUserInfo.waitBingting": "Đang liên kết... Vui lòng chờ...",
  "editUserInfo.collapse": "Thu gọn",
  "editUserInfo.modifyBinding": "Chỉnh sửa liên kết",
  
  "editUserInfo.emailAddress": "Địa chỉ email",
  "editUserInfo.tips1": "Liên kết email thành công",
  "editUserInfo.tips2": "Lưu thất bại",
  "editUserInfo.tips3": "Đang gửi mã xác minh email... Vui lòng chờ...",
  "editUserInfo.tips4": "Mã xác minh đã gửi đến email xxxx, vui lòng kiểm tra",
  "editUserInfo.tips5": "Gửi mã xác minh thất bại!",
  "editUserInfo.tips6": "Số điện thoại đã được liên kết",
  "editUserInfo.tips7": "Email đã được liên kết",
  "editUserInfo.emailTips1": "Nhập địa chỉ email",
  "editUserInfo.emailTips2": "Định dạng email không hợp lệ",
  "editUserInfo.emailTips3": "Sau xxxx giây có thể gửi lại",
  "editUserInfo.emailTips4": "Gửi mã xác minh",
  "editUserInfo.emailTips5": "Mã xác minh email không được để trống",
  "editUserInfo.emailTips6": "Mã xác minh email không hợp lệ",
  "editUserInfo.emailCode": "Mã xác minh email",
  "editUserInfo.save": "Lưu",

  "editUserInfo.phoneTips1": "Liên kết số điện thoại thành công",
  "editUserInfo.phoneTips2": "Đang gửi mã xác minh SMS... Vui lòng chờ...",
  "editUserInfo.phoneTips3": "Mã xác minh SMS đã gửi đến số điện thoại xxxx, vui lòng kiểm tra",
  "editUserInfo.phoneTips4": "Gửi mã xác minh SMS thất bại!",
  "editUserInfo.phoneTips5": "Nhập số điện thoại",
  "editUserInfo.phoneTips6": "Định dạng số điện thoại không hợp lệ",
  "editUserInfo.phoneTips7": "Gửi mã xác minh SMS",
  "editUserInfo.phoneTips8": "Mã xác minh SMS",
  "editUserInfo.phoneTips9": "Mã xác minh SMS không được để trống",
  "editUserInfo.phoneTips10": "Mã xác minh SMS không hợp lệ",
  "editUserInfo.phone": "Số điện thoại",


  "editUserInfo.noticeTips1": "Lấy cài đặt thông báo thất bại!",
  "editUserInfo.noticeTips2": "Cài đặt thông báo đã lưu thành công!",
  "editUserInfo.noticeTips3": "Thông báo mức pin thấp",
  "editUserInfo.noticeTips4": "Thông báo hoàn thành sạc bộ sạc",
  "editUserInfo.errorNotification": "Thông báo lỗi",
  "editUserInfo.updateNotification": "Thông báo cập nhật",
  "editUserInfo.monthlyStatisticsNotification": "Thông báo thống kê hàng tháng",
  "editUserInfo.notificationMethod": "Phương thức nhận",

  "editUserInfo.userNameTips1": "Tên đăng nhập đã lưu thành công",
  "editUserInfo.userNameTips2": "Lưu tên đăng nhập thất bại",
  "editUserInfo.userNameTips3": "Nhập tên đăng nhập",
  "editUserInfo.userNameTips4": "Định dạng tên đăng nhập không hợp lệ: chỉ có thể chứa số, dấu gạch dưới và chữ tiếng Anh",
  "editUserInfo.userNameTips5": "Nhập tên đăng nhập",
  "editUserInfo.userNameTips6": "Đang lưu... Vui lòng chờ...",
  "editUserInfo.userName": "Tên đăng nhập",

  "editUserInfo.avatorTips": "Nhấn để thay đổi ảnh đại diện",
  "editUserInfo.verifyCodeTips1": "Nhập mã xác minh đã nhận:",
  "editUserInfo.verifyCodeTips2": "Để đảm bảo an toàn tài khoản, vui lòng nhấn nút dưới đây để gửi mã xác minh đến số điện thoại gốc:",
  "editUserInfo.verifyCodeTips3": "Gửi mã xác minh",
  "editUserInfo.verifyCodeTips4": "Xác minh số điện thoại gốc thành công, vui lòng nhập số điện thoại mới đã liên kết",
  "editUserInfo.verifyCodeTips5": "Để đảm bảo an toàn tài khoản, vui lòng nhấn nút dưới đây để gửi mã xác minh đến email gốc:",
  "editUserInfo.verifyCodeTips6": "Xác minh email gốc thành công, vui lòng nhập email mới",
  "editUserInfo.verifyCodeTips7": "Mật khẩu cũ",
  "editUserInfo.verifyCodeTips8": "Trước tiên, vui lòng liên kết email!",
  "editUserInfo.verifyCodeTips9": "Mã xác minh đã gửi đến email, vui lòng kiểm tra",
  "editUserInfo.verifyCodeTips10": ", sẽ tự động chuyển đến trang đăng nhập",

  "hems.notice.title": "Tiêu đề thông báo", 
  "hems.notice.content": "Nội dung thông báo", 
  "hems.notice.operate": "Thao tác",
  "hems.notice.noRead": "Chưa đọc",
  "hems.notice.read": "Đã đọc",
  "hems.notice.warning": "Cảnh báo",
  "hems.notice.error": "Lỗi",
  "hems.notice.success": "Tính toán thống kê",
  "hems.notice.sys": "Thông tin hệ thống",
  "hems.notice.operateSuccess": "Thao tác thành công",
  "hems.notice.operateTips": "Chọn mục để thao tác",

  // 首页
  "hems.home.selfuseRate": "Tỷ lệ tự sử dụng",
  "hems.home.percent": "Tỷ lệ (%)",
  "hems.home.todayData": "Dữ liệu hôm nay",
  "hems.home.todayPowerGeneration": "Sản lượng năng lượng hôm nay",
  "hems.home.salesIncome": "Doanh thu bán năng lượng",
  "hems.home.saved": "Bạn đã tiết kiệm",
  "hems.home.reduce": "Giảm dấu chân carbon",
  "hems.home.tips1": "Hiện không có dữ liệu, bạn chưa liên kết xxxx",
  "hems.home.criticalLoad": "Tải trọng nguy cấp",
  "hems.home.keyVoltage": "Điện áp nguy cấp",
  "hems.home.householdLoad": "Tải trọng nhà ở",
  "hems.home.householdVoltage": "Điện áp nhà ở",
  "hems.home.generalLoad": "Tải trọng thông thường",
  "hems.home.generalVoltage": "Điện áp thông thường",
  "hems.home.batteryHealth": "Trạng thái sức khỏe pin",
  "hems.home.averageTemp": "Nhiệt độ trung bình",
  "hems.home.gridLoad": "Tải trọng mạng điện",
  "hems.home.toggeleDataSource": "Dữ liệu hiển thị hiện tại đã chuyển sang:",
  "hems.home.toggleTips": "Bạn có chắc chắn muốn chuyển đổi không?",
  "hems.home.modeSending": "Đang gửi lệnh chế độ... Vui lòng chờ...",
  "hems.home.modeSuccess": "Lệnh chuyển chế độ đã gửi thành công!",
  "hems.home.isOnline": "Có online không?",
  "hems.home.useStatus": "Trạng thái sử dụng",
  "hems.home.workModeText": "Chế độ làm việc hiện tại:",
  "hems.home.toggleDataSourceText": "Dữ liệu hiển thị hiện tại đã chuyển sang:",
  "hems.ev.charge.status": "Trạng thái sạc",
  "hems.ev.charge.time": "Thời gian sạc",
  "hems.ev.charge.count": "Lượng sạc theo thời gian thực",
  "hems.ev.charge.status.empty": "Trống",
  "hems.ev.charge.status.ing": "Đang sạc với cáp đã kết nối",
  "hems.ev.charge.status.null": "Cáp đã kết nối nhưng không sạc",
  "hems.ev.charge.status.error": "Lỗi",
  "hems.hour": "giờ",
  "hems.minue": "phút",
  "hems.ev.chagre.number": "Số thứ tự bộ sạc",

  // User Guide
  "hems.userGuide.selfUse": "Tự sử dụng năng lượng tự sản xuất",
  "hems.userGuide.selfUseTips": "Ưu tiên sử dụng năng lượng quang điện, nếu không đủ, hãy bổ sung từ mạng điện",
  "hems.userGuide.economyMode": "Chế độ kinh tế",
  "hems.userGuide.economyModeTips": "Tối ưu hóa chiến lược sử dụng năng lượng theo giá điện",
  "hems.userGuide.emergencyMode": "Chế độ khẩn cấp",
  "hems.userGuide.emergencyModeTips": "Ưu tiên đảm bảo nguồn cung cấp năng lượng cho tải trọng nguy cấp",

  // 图表页面
  "hems.history.energyStatistics": "Thống kê năng lượng",
  "hems.history.revenueStatistics": "Thống kê doanh thu",
  "hems.history.greenStatistics": "Giảm thiểu khí thải xanh",
  "hems.history.revenueTitle": "Tổng doanh thu bán năng lượng",
  "hems.history.savingsTitle": "Tổng tiền tiết kiệm",
  "hems.history.carbonTitle": "Tổng lượng giảm thiểu carbon",
  "hems.history.day": "ngày",
  "hems.history.month": "tháng",
  "hems.history.year": "năm",
  "hems.history.beforeDay": "Ngày trước",
  "hems.history.afterDay": "Ngày sau",
  "hems.history.beforeMonth": "Tháng trước",
  "hems.history.afterMonth": "Tháng sau",
  "hems.history.beforeYear": "Năm trước",
  "hems.history.afterYear": "Năm sau",
  "hems.history.totalUse": "Tổng tiêu thụ",
  "hems.history.fullScreen": "Toàn màn hình",
  "hems.history.timeSelect": "Chọn ngày",
  "sync.tips1": "Lệnh đồng bộ dữ liệu đã gửi thành công!",
  "sync.tips2": "Đang đồng bộ dữ liệu, do dung lượng dữ liệu lớn nên cần thời gian, vui lòng kiểm tra lại sau nửa giờ~",
  "sync.tips3": "Đồng bộ dữ liệu thiết bị có thể bị trễ, nếu bạn phát hiện bất kỳ sự không khớp nào trong dữ liệu, vui lòng nhấn vào:",
  "sync.tips4": "Đồng bộ dữ liệu",

  "charge.info": "Thông tin bộ sạc",
  "news.loading": "Đang tải...",
  "news.noMore": "Không có thêm dữ liệu",
  "hems.pv.power": "Lượng năng lượng quang điện",

  // UEH specific
  "ueh.sellPower": "Lượng năng lượng đã bán",
  
  "menu.home": "Trang chủ",
  "menu.history": "Dữ liệu lịch sử",
  "menu.device": "Thiết bị",
  "menu.settings": "Cài đặt",
  "menu.messageCenter": "Trung tâm tin nhắn",
  "menu.help": "Trợ giúp và hỗ trợ",
  "menu.mine": "Cá nhân của tôi",


  "mine.userSetting": "Cài đặt người dùng",
  "mine.terminalSetting": "Cài đặt cơ bản thiết bị đầu cuối",
  "mine.uploadCloud": "Tải dữ liệu lên đám mây",
  "mine.changeVersion": "Kiểm tra cập nhật",
  "mine.language": "Thay đổi ngôn ngữ",
  "mine.about": "Về ứng dụng",
  "mine.feedback": "Phản hồi",
  "mine.logout": "Đăng xuất",
  "mine.logoutAccount": "Xóa tài khoản",

  "mine.logoutAccountTips": "Xóa tài khoản tên []",
  "mine.logoutAccountTips1": "Xóa tài khoản đã liên kết với []",
  "mine.logoutAccountCare": "Lưu ý về yêu cầu xóa tài khoản:",
  "mine.logoutAccountCare1": "1. Tài khoản đang ở trạng thái an toàn",
  "mine.logoutAccountCare1-1": "Tài khoản đang ở trạng thái sử dụng bình thường, không có rủi ro bị đánh cắp, vi phạm quy tắc hoặc bị chặn.",
  "mine.logoutAccountCare2": "2. Quyền truy cập và liên kết của tài khoản đã bị xóa",
  "mine.logoutAccountCare2-1": "Tất cả quyền truy cập của tài khoản với các nền tảng bên thứ ba đã bị xóa.",
  "mine.logoutAccountCare3": "3. Sau khi xóa tài khoản, không thể khôi phục lại, dữ liệu người dùng sẽ bị xóa",
  "mine.logoutAccountCare3-1": "Sau khi xóa tài khoản, số điện thoại, email và dữ liệu khác đã liên kết sẽ bị xóa và không thể khôi phục.",
  "mine.confirmLogout": "Xác nhận xóa",
  "mine.logoutSuccess": "Tài khoản đã xóa thành công!",


  "mine.feedbackIssues": "Phản hồi về vấn đề",
  "mine.feedQuantity": "Số lượng",
  "mine.feedAmount": "Tối đa 9 ảnh, dung lượng tối đa 1 MB/ảnh",

  "mine.notice.fail": "Lấy cài đặt thông báo thất bại!",
  "mine.notice.saveSuccess": "Cài đặt thông báo đã lưu thành công!",
  "mine.notice.saveFail": "Lưu thất bại!",
  "mine.notice.title": "Cài đặt thông báo",
  "mine.notice.batteryLow": "Thông báo mức pin thấp",
  "mine.notice.chargingFinish": "Thông báo hoàn thành sạc bộ sạc",
  "mine.notice.error": "Thông báo lỗi",
  "mine.notice.update": "Thông báo cập nhật",
  "mine.notice.monthly": "Thông báo thống kê hàng tháng",
  "mine.notice.receiveType": "Phương thức nhận",

  "mine.language.welcome": "Chào mừng đến SusprSafe",
  "mine.language.desc1": "Vui lòng chọn phiên bản ngôn ngữ theo nơi ở của bạn",
  "mine.language.desc2": "Bạn có thể thay đổi nó bất cứ lúc nào trong cài đặt ứng dụng",

  "mine.userInfo.avatar": "Ảnh đại diện",
  "mine.userInfo.nickname": "Biệt danh",
  "mine.userInfo.password": "Mật khẩu",
  "mine.userInfo.changePassword": "Thay đổi mật khẩu",
  "mine.userInfo.setPassword": "Đặt mật khẩu",
  "mine.userInfo.phoneNumber": "Số điện thoại",
  "mine.userInfo.bindPhone": "Liên kết số điện thoại",
  "mine.userInfo.bindEmail": "Liên kết email",
  "mine.loginExpired": "Trạng thái đăng nhập đã hết hạn, vui lòng đăng nhập lại",
  "mine.userInfo.title": "Thông tin người dùng",
  "mine.userInfo.bind": "Liên kết",
  "mine.userInfo.modify": "Chỉnh sửa",
  "mine.userInfo.modifyNickname": "Thay đổi biệt danh",
  "mine.userInfo.userNickname": "Biệt danh người dùng",
  "mine.userInfo.selectPic": "Chọn ảnh để tải lên",
  "mine.userInfo.saveSuccess": "Lưu thành công",
  "mine.userInfo.uploadFail": "Tải lên thất bại",
  "mine.userInfo.avatarSaveSuccess": "Ảnh đại diện đã lưu thành công",
  "mine.userInfo.nameTips1": "Biệt danh người dùng không được để trống",
  "mine.userInfo.nameTips2": "Nhập biệt danh người dùng",

  "common.pleaseSelect": "Vui lòng chọn",
  "question.commonQuestions": "Câu hỏi thường gặp",
  "account.toggleLanguage": "Thay đổi ngôn ngữ",
  "account.localConnection": "Kết nối cục bộ",
  "account.selectLanguage": "Vui lòng chọn ngôn ngữ",
  "account.sendEmailToast": "Mã xác minh đã gửi đến email xxx, vui lòng kiểm tra",
  "account.emailError": "Định dạng email không hợp lệ",
  "account.sendEmailFail": "Gửi thất bại, vui lòng thử lại",
  
  "common.submitting": "Đang gửi... Vui lòng chờ...",

  "device.page.noData": "Hiện không có dữ liệu, trang này chỉ có thể xem trong ứng dụng"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Nâng cấp",
  "bmsFirmware.upgrading": "Đang nâng cấp...",
  "bmsFirmware.uploadingFile": "Đang tải lên tệp firmware...",
  "bmsFirmware.upgradingProgress": "Đang nâng cấp firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Nâng cấp thành công",
  "bmsFirmware.upgradeSuccessSubtitle": "Nâng cấp firmware BMS hoàn tất!",
  "bmsFirmware.upgradeFailed": "Nâng cấp thất bại",
  "bmsFirmware.upgradeFailedFormError": "Vui lòng kiểm tra xem biểu mẫu có được điền chính xác không",
  "bmsFirmware.upgradeFailedNetworkError": "Lỗi mạng, vui lòng thử lại",
  "bmsFirmware.invalidFileType": "Vui lòng chọn tệp firmware hợp lệ (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Vui lòng chọn tệp firmware trước",
  "bmsFirmware.statusUpgrading": "Đang nâng cấp",
  "bmsFirmware.statusCompleted": "Nâng cấp hoàn tất",
  "bmsFirmware.statusFailed": "Nâng cấp thất bại",
  "bmsFirmware.deviceUpgrading": "Đang nâng cấp gói firmware, quá trình nâng cấp mất 30-50 phút, không thể xem dữ liệu thiết bị theo thời gian thực trong thời gian này, vui lòng chờ...",
  "bmsFirmware.upgradeStatusLabel": "Trạng thái nâng cấp",
  "bmsFirmware.upgradeProgressLabel": "Tiến độ nâng cấp",
  "bmsFirmware.currentPackageLabel": "Số gói dữ liệu hiện tại đã truyền",
  "bmsFirmware.totalPackagesLabel": "Tổng số gói dữ liệu",
  "bmsFirmware.upgradeFailedCheckDevice": "Vui lòng kiểm tra trạng thái thiết bị và thử nâng cấp lại",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Cài đặt thành công",
  "settingResult.defaultSubTitle": "Cài đặt tham số đã được lưu",
  "settingResult.confirmButton": "OK"
};